/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class ProfitMargin extends React.PureComponent {
  render() {
    const { onChange, value } = this.props

    return (
      <Form.Field required>
        <label>Profit Margin</label>
        <Input
          required
          label={{ content: '%' }}
          labelPosition="right"
          placeholder="e.g 10"
          type="number"
          min={0}
          step={0.01}
          max={100}
          value={value}
          onChange={e => onChange(e.target.value)}
        />
      </Form.Field>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/deliveryFeeOffer/fields/profitMarginField.js